<vc-spinner *ngIf="loadingSchedule"></vc-spinner>

<div
   id="calendly-container"
   class="calendly-inline-widget"
   style="position: relative; z-index: 3; top: -50px; min-width: 100%; height: 680px"></div>
